/* Core & libraries */
import React, {useEffect, useState} from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import { useUserContext } from "../../../contexts/userContext";

/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";
import Footer from "./footer";
import { ReactComponent as GlobalSvg } from '../../../resources/images/building.svg';

/* Styles */
import styles from "./styles";


const CompaniesSwitchModal = ({showModal, setShowModal, changeCompany}) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const userDetails = useUserContext();
  const companies = userDetails.profileSelector;
  const [selectedCompany, setSelectedCompany] = useState(companies ? companies.find(item => item.companyEntityID === userDetails?.userInfo?.companyInfo?.companyEntityId) : null)

  const handleModalExit = () => {
    setSelectedCompany(companies ? companies.find(item => item.companyEntityID === userDetails?.userInfo?.companyInfo?.companyEntityId) : null);
  };

  const handleSaveModal = async () => {
    const response = await changeCompany(selectedCompany)
    if (response) {
      setShowModal(false)
    }
  }

  const onChange = (item) => {
    setSelectedCompany(item)
  }

  return (
    <UCModal
      className={classes.companiesSwitcherModal}
      showModal={ showModal }
      setShowModal={ setShowModal }
      modalIcon={ <GlobalSvg /> }
      modalTitle={ <FormattedMessage id="companiesSwitcherModal.title"/> }
      modalDescription={ <FormattedMessage id="companiesSwitcherModal.description"/> }
      modalContent={ <Content selectedCompany={selectedCompany} companies={companies} onChange={onChange} /> }
      modalFooter={ <Footer setShowModal={setShowModal} handleSaveModal={handleSaveModal}/> }
      dataTestId="companiesswitchermodal"
      onExited={handleModalExit}
    />
  )
}

export default CompaniesSwitchModal;
